var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiniarrowdown = function SvgMiniarrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 4,
    viewBox: "0 0 8 4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6312D",
    fillRule: "evenodd",
    d: "m0 0 4 1.5L8 0 4 4z"
  })));
};
export default SvgMiniarrowdown;